export const frontmatter = {
    "draft": false,
    "title": "Organizations",
    "description": "Organization management in OnnIA.",
    "sidebar_label": "Organizations",
    "sidebar_group": "reference",
    "sidebar_order": 1
}

export const toc = []